import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import * as moment from "moment";
import {
    DESCARGAR_REPORTE_XLS,
    EXITO_DESCARGAR_REPORTE_XLS,
    ERROR_DESCARGAR_REPORTE_XLS,
    exitoDescargarReporteXLS,
    errorDescargarReporteXLS
} from "./descargaReporteActions";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { TipoReportes } from "../modelo/TiposReporte";


export const descargarReporteXLSEpic = action$ =>
    action$.ofType(DESCARGAR_REPORTE_XLS)
        .mergeMap((action: any) => {

            const tipoReporte = action.tipo;
            const url = `sat/consultar/reporte-excel?${obtenerFiltro(tipoReporte)}`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        `REPORTE_${TipoReportes[tipoReporte]}_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return exitoDescargarReporteXLS();
                }).catch(response =>
                    [errorDescargarReporteXLS()]
                );
        });


export const descargarReporteXLSReducer = (state = {
    estado: REQUEST.NONE,
    periodos: [],
    paginas: 0,
    totalPeriodosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case DESCARGAR_REPORTE_XLS:
        case EXITO_DESCARGAR_REPORTE_XLS:
        case ERROR_DESCARGAR_REPORTE_XLS:
            return {
                ...state
            };
        default:
            return state;
    }
};

const obtenerFiltro = (tipo: TipoReportes) => {
    const tipoReporte = TipoReportes[tipo];
    let params = new URLSearchParams();
    if (tipoReporte) {
        params.set('entidadBD', tipoReporte);
    }
    return params.toString();
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/descarga_reporte/modulos/descargaReporteReducers.ts